import React from "react";

import { Route, Routes } from "react-router-dom";
import "./App.css";
import QuickQuote from "./HealthInsurance/QuickQuote/QuickQuote";
import ListOfProducts from "./HealthInsurance/ListOfProducts/ListOfProducts";
import LifeInsuranceQQ from "./LifeInsurance/QuickQuote/LifeInsuranceQQ";
import PolicyHighlightPage from "./HealthInsurance/PolicyHighlightPage/PolicyHighlightPage";
import NotFound from "./NotFound/NotFound";
import Policy from "./HealthInsurance/CreateQuote/Policy";
import PaymentOptions from "./HealthInsurance/Payment/PaymentOptions";
import ProductListCard from "./LifeInsurance/ListOfProducts/ProductListCard";
import ProductDetailsPage from "./LifeInsurance/PolicyHighlightPage/ProductDetailsPage";
import Validateproposal from "./LifeInsurance/CreateQuote/ValidateProposer/Validateproposal";
import GetBiForm from "./LifeInsurance/CreateQuote/GetBiForm/GetBiForm";
import CreateQuoteForm from "./LifeInsurance/CreateQuote/SubmitProper/CreateQuoteForm";
import PaypremiumForm from "./LifeInsurance/CreateQuote/PaypremiumForm/PaypremiumForm";
import HealthInsPolicyStatus from "./HealthInsurance/PolicyStatus/HealthInsPolicyStatus";
import PaymentPage from "./HealthInsurance/Payment/PaymentPage";
import PaymentStatus from "./LifeInsurance/Payment/PaymentStatus";

import BiDocumentPage from "./LifeInsurance/BiDocument/BiDocumentPag";
import LifePaymentOptions from "./LifeInsurance/Payment/LifePaymentOptions";
import AgentVerification from "./AgentAuthentication/AgentVerification";
import EKYC_ReturnUrl from "./AgentAuthentication/CareHealthKYC/EKYC/EKYC_ReturnUrl";
import PortalRedirectUrl from "./AgentAuthentication/HdfcErgoKYC/Utilities/PortalRedirectUrl.js";
import DocUpload from "./AgentAuthentication/CareHealthKYC/UploadDocument/DocUpload";
import ProposerStatus from "./LifeInsurance/ProposerStatus/ProposerStatus";

import ThankYouPage from "./LifeInsurance/Payment/ThankYouPage";

import HdfcErgoPaymentStatus from "./HealthInsurance/Payment/HdfcErgoPaymentStatus";
import HdfcErgoPolicyStatus from "./HealthInsurance/PolicyStatus/HdfcErgoPolicyStatus";
import HealthThankYouPage from "./HealthInsurance/PolicyStatus/HealthThankYouPage";
import { default as PersonalAccidentQuickQuote } from "./PersonalAccident/QuickQuotePage/QuickQuote";
import {
  CREATE_QUOTE_PAGE_ROUTE,
  PAYMENT_PAGE_FOR_CUSTOMER_ROUTE,
  PAYMENT_OPTIONS_PAGE_ROUTE,
  PAYMENT_STATUS_ROUTE,
  POLICY_HIGHLIGHT_PAGE_ROUTE,
  POLICY_STATUS_ROUTE,
  PRODUCT_LISTING_PAGE_ROUTE,
  PROPOSAL_CREATION_PAGE_ROUTE,
  QUICK_QUOTE_ROUTE,
  THANK_YOU_PAGE_ROUTE,
} from "./PersonalAccident/routes";
import { default as PAProductListingPage } from "./PersonalAccident/ProductListingPage/ProductListing";
import { default as PAPolicyHighlightPage } from "./PersonalAccident/PolicyHighlightPage/PolicyHighlight";
import { default as PACreateQuotePage } from "./PersonalAccident/CreateQuotePage/CreateQuote";
import { default as PAProposalCreation } from "./PersonalAccident/ProposalCreationPage/ProposalCreation";
import { default as PAPaymentOptionsPage } from "./PersonalAccident/PaymentOptionsPage/PaymentOptions";
import { default as PAPaymentPageForCustomer } from "./PersonalAccident/PaymentPageForCustomer/PaymentPageForCustomer";
import { default as PAPaymentStatus } from "./PersonalAccident/PaymentStatusPage/PaymentStatus";
import { default as PAPolicyStatus } from "./PersonalAccident/PolicyStatusPage/PolicyStatus";
import { default as PAThankYouPage } from "./PersonalAccident/ThankYouPage/ThankYou";
import { CREATE_QUOTE_PAGE_ROUTE as CREATE_QUOTE_PAGE_ROUTE_HEALTH_INSURANCE_NEW } from "./HealthInsuranceNew/routes";
import { default as HICreateQuotePageNew } from "./HealthInsuranceNew/CreateQuote/CreateQuotePage";

import GoDigitPaymentStatus from "./HealthInsuranceNew/Products/GoDigit/Components/GoDigitPaymentStatus";
import GoDigitDownloadPage from "./HealthInsuranceNew/Products/GoDigit/Components/GoDigitDownloadPage.jsx";

import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import CustomerRoutes from "./AcuvisorCustomerApp/Routes/CustomerRoutes.js";
import SignIn from "./AcuvisorCustomerApp/components/userAuth/SignIn.jsx";
import HumanLifeValue from "./AcuvisorCustomerApp/components/humanlifevalue/HumanLifeValue.jsx";
import OTPPage from "./HealthInsurance/OTPPage/OtpPage.js";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import LearnAboutPOSP from "./AcuvisorCustomerApp/components/StartAsPOSP/LearnAboutPOSP.jsx";

// Create a react query client
const queryClient = new QueryClient();

function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <div className="App-body">
        <ToastContainer />

        <Routes>
          <Route path="/*" element={<CustomerRoutes />} />
          <Route
            path="/health-insurance/otp/:productId"
            element={<OTPPage />}
          />
          {/*  <Route path="/care" element={<QuickQuote />} /> */}
          {/*Todo: this will be removed or handled more optimized*/}
          <Route path="/signin" element={<SignIn defaultOpen={true} />} />
          <Route
            path="/customer/human-life-value"
            element={<HumanLifeValue />}
          />
          <Route
            path="/customer/learn-about-posp"
            element={<LearnAboutPOSP />}
          />
          <Route
            path="/health-insurance"
            search="?data=sai"
            element={<QuickQuote />}
          />
          <Route
            path="/health-insurance/products-list/"
            element={<ListOfProducts />}
          />
          <Route
            path="/health-insurance/product-detail/:productId"
            element={<PolicyHighlightPage />}
          />
          <Route
            path="/health-insurance/product/:productId"
            element={<Policy />}
          />
          <Route
            path="/health-insurance/product-stastus/:referencetId"
            element={<PaymentOptions />}
          />
          <Route
            path="/health-insurance/policy-status/:proposerNum"
            element={<HealthInsPolicyStatus />}
          />{" "}
          {/* redirect url */}
          <Route
            path="/health-insurance/hdfc-ergo-product-status/:referencetId"
            element={<HdfcErgoPolicyStatus />}
          />
          <Route
            path="/health-insurance/thankyou"
            element={<HealthThankYouPage />}
          />
          <Route
            path="/health-insurance/ckyc/:productId"
            element={<AgentVerification />}
          />
          <Route
            path="/health-insurance/ekyc/:productId"
            element={<EKYC_ReturnUrl />}
          />{" "}
          {/* Return url for care ekyc */}
          <Route
            path="/health-insurance/hdfc-kyc-redirect/:productId"
            element={<PortalRedirectUrl />}
          />{" "}
          {/* Return url for hdfc ekyc */}
          <Route
            path="/health-insurance/payment-status"
            search="?data=ew"
            element={<HdfcErgoPaymentStatus />}
          />{" "}
          {/* Return url for hdfc ekyc */}
          <Route
            path="/health-insurance/kyc_document_upload/:referencetId"
            element={<DocUpload />}
          />
          <Route
            path="/payment/:id"
            search="?aid&&prod_id"
            element={<PaymentPage />}
          />{" "}
          {/* SMS Payment Option */}
          <Route
            path={`${CREATE_QUOTE_PAGE_ROUTE_HEALTH_INSURANCE_NEW}/:transferDataId/:acuvisorProductId`}
            element={<HICreateQuotePageNew />}
          />
          <Route
            path="/health-insurance/payment-status/go-digit/"
            search="?data=ew"
            element={<GoDigitPaymentStatus />}
          />{" "}
          {/* Return url for goDigit payment*/}
          <Route
            path="/health-insurance/policy-pdf-download/go-digit/"
            search="?data=ew"
            element={<GoDigitDownloadPage />}
          />
          {/* <Route
            path="/life-insurance"
            search="?data=sai"
            element={<LifeInsuranceQQ />}
          /> */}
          <Route
            path="/life-insurance/products-list/:id"
            element={<ProductListCard />}
          />
          <Route
            path="/life-insurance/product-detail/:id"
            element={<ProductDetailsPage />}
          />
          <Route
            path="/life-insurance/validateproposal/:id"
            element={<Validateproposal />}
          />
          <Route path="/life-insurance/getbi/:id" element={<GetBiForm />} />
          <Route
            path="/life-insurance/bi_document/:id"
            element={<BiDocumentPage />}
          />
          <Route
            path="/life-insurance/paypremium/:id"
            element={<PaypremiumForm />}
          />
          <Route
            path="/life-insurance/payment-options/:id"
            element={<LifePaymentOptions />}
          />
          <Route
            path="/lifeInsurance/paymentStatus/:id"
            element={<PaymentStatus />}
          />
          {/* Return url for life */}
          <Route
            path="/life-insurance/submitproposal/:id"
            element={<CreateQuoteForm />}
          />
          <Route
            path="/life-insurance/proposerStatus/:id"
            element={<ProposerStatus />}
          />
          <Route path="/thankyou/:id" element={<ThankYouPage />} />
          <Route path="*" element={<NotFound />} />
          {/* Personal Accident routes */}
          <Route
            path={QUICK_QUOTE_ROUTE}
            element={<PersonalAccidentQuickQuote />}
          />
          <Route
            path={`${PRODUCT_LISTING_PAGE_ROUTE}/`}
            element={<PAProductListingPage />}
          />
          <Route
            path={`${POLICY_HIGHLIGHT_PAGE_ROUTE}/:productRef/:transferDataId/:acuvisorProductId`}
            element={<PAPolicyHighlightPage />}
          />
          <Route
            path={`${CREATE_QUOTE_PAGE_ROUTE}/:productRef/:transferDataId`}
            element={<PACreateQuotePage />}
          />
          <Route
            path={`${PROPOSAL_CREATION_PAGE_ROUTE}/`}
            element={<PAProposalCreation />}
          />
          <Route
            path={`${PAYMENT_OPTIONS_PAGE_ROUTE}/:transferDataId`}
            element={<PAPaymentOptionsPage />}
          />
          <Route
            path={`${PAYMENT_PAGE_FOR_CUSTOMER_ROUTE}/:transferDataId`}
            element={<PAPaymentPageForCustomer />}
          />
          <Route
            path={`${PAYMENT_STATUS_ROUTE}/`}
            element={<PAPaymentStatus />}
          />
          <Route
            path={`${POLICY_STATUS_ROUTE}/:transferDataId`}
            element={<PAPolicyStatus />}
          />
          <Route path={THANK_YOU_PAGE_ROUTE} element={<PAThankYouPage />} />
        </Routes>
      </div>

      <ReactQueryDevtools
        initialIsOpen={false}
        buttonPosition="bottom-left"
        position="bottom"
      />
    </QueryClientProvider>
  );
}

export default App;
